import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { getRefreshToken } from "../services/tokenService";

const PrivateRoutes = () => {
    const token = getRefreshToken();
    const location = useLocation();

    return token ? <Outlet/> : <Navigate to="/login" replace state={{from: location}}/>;

};

export default PrivateRoutes;
